import flatten from "lodash/flatten";
import React from "react";
import { type TemplateFormGroup } from "../model";
import TemplateEditSection from "./TemplateEditSection";

interface TemplateEditFormProps {
  formGroups: TemplateFormGroup[]
  onChange: (formGroups: TemplateFormGroup[]) => void
}

export const getDefaultFormGroups = (formGroups: TemplateFormGroup[]): TemplateFormGroup[] => formGroups.map(group => ({
  ...group,
  rows: group.rows.map(row => ({
    ...row,
    formElementBehavior: "visibleOptional"
  }))
}));

export const getTemplateRows = (formGroups: TemplateFormGroup[]): server.dto.SetAdvancingTemplateRowInstruction[] => {
  const rows = flatten(formGroups.map(group => group.rows));

  return rows.filter(row => row.formElementBehavior !== "notVisible").map(row => ({
    advancingChunkId: row.advancingChunkId,
    formElementBehavior: row.formElementBehavior
  }));
};

export const TemplateEditForm = (props: TemplateEditFormProps) => {
  const onRowChange = (advancingChunkId: string, behavior: server.dto.FormElementBehaviors) => {
    props.onChange(props.formGroups.map(group => ({
      ...group,
      rows: group.rows.map(row => row.advancingChunkId === advancingChunkId ? { ...row, formElementBehavior: behavior } : row)
    })));
  }

  const onGroupChange = (changedGroup: TemplateFormGroup, behavior: server.dto.FormElementBehaviors) => {
    props.onChange(props.formGroups.map(group => {
      if (group !== changedGroup) return group;

      return {
        ...group,
        rows: group.rows.map(row => ({ ...row, formElementBehavior: behavior }))
      };
    }));
  }

  return <div className="advancing-template-grid">
    {props.formGroups.map((group, idx) => (
      <TemplateEditSection
        key={idx}
        group={group}
        onChange={onRowChange}
        onSectionTypeChange={onGroupChange}
      />
    ))}
  </div>
}
